import { description } from './../../models/books.model';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import * as _ from 'lodash';

@Component({
  selector: 'app-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss']
})
export class ChipsComponent  implements OnInit {

  @Input() allitems: description[] = [];
  @Input() itemsLabel:string = '';
  @Input() newItemLabel:string = '';
  @Input() maxItems = 5;
  @Input() defaultValues: description[] = [];
  @Output() selectedItems = new EventEmitter<Array<description>>();
  @Input() disabled = false;
  
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  itemCtrl = new FormControl();
  filtereditems: Array<description>;
  items:  description[] = [];
  
  @ViewChild('itemInput') itemInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor() { 
         this.itemCtrl.valueChanges.subscribe((data)=> {
         this.filtereditems =  _.filter(this.allitems, function(o) { return (o && data) ? o.descrizione.toLowerCase().includes(data.toLowerCase()) > 0 : [] });
   })
  }

  ngOnInit(): void { 
      if (this.defaultValues.length > 0)  {
        this.items = this.defaultValues; 
      }
  }
 
  remove(item: description): void {
    const index = _.findIndex(this.items, item);
    this.items.splice(index, 1 );
    this.selectedItems.emit(this.items);
    if (this.items.length < this.maxItems) {
      this.disabled = false;
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const SelectedElement = _.filter(this.allitems, { cod: event.option.value });
    this.items.push(SelectedElement[0]);
    this.itemInput.nativeElement.value = '';
    this.itemCtrl.setValue(null);
    this.selectedItems.emit(this.items);
    this.filtereditems = [];
    if (this.items.length === this.maxItems) {
      this.disabled = true;
    }
  }

  

}
